import { Grid } from '@mui/material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';
import { ControlledTextField } from '../../../../../components/forms';
import { OperacionADCMFields } from '../types/fields';

export const SeccionNuevoADCMUnderwriting = ({ formMethods }: { formMethods: UseFormReturn<any> }) => {
  const { control } = formMethods;

  const watchUnderwriting = useWatch({
    control,
    name: OperacionADCMFields.Underwriting
  });

  if (watchUnderwriting !== 1) return <></>;

  return (
    <CardActions title='Detalle de Underwriting' icon='mdi:shield-check-outline' colapsable>
      <SectionBox>
        <Grid item xs={12}>
          <ControlledTextField
            label='Monto'
            name={OperacionADCMFields.UnderWritingMonto}
            control={control}
            currency
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            label='Underwriting - Fee'
            name={OperacionADCMFields.UnderWritingFee}
            control={control}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            label='Observaciones / Condiciones particulares'
            name={OperacionADCMFields.UnderWritingObservaciones}
            control={control}
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </SectionBox>
    </CardActions>
  );
};
